import {Store} from "@/model/Store";

export class SelectableStore {
    store: Store;
    checked: boolean;
    displayed: boolean;

    constructor(store: Store, checked: boolean = false, displayed: boolean = true) {
        this.store = store;
        this.checked = checked;
        this.displayed = displayed;
    }
}
